import api from './api';

const AuthService = {
    login: (data) => api.post('auth/client', data),
    refresh: () => api.get('auth/client'),
    firstAccess: (cpf) => api.get('auth/first-access', { params: { cpf } }),
    firstAccessLogin: (data) => api.post('auth/first-access', data),
};

export default AuthService;